import {
  DataQueryKey,
  UseDataQuery,
  UseDataQueryKey,
} from '../../../hooks/useDataQuery/dataQuery.types';
import {
  FindOrderConditionFreightQuotesParams,
  FindOrderConditionParams,
  FindOrderConditionsClassificationTypesParams,
} from './orderCondition.types';

export const getFindOrderConditionsKey = (params: FindOrderConditionParams): UseDataQueryKey => {
  return [DataQueryKey.ORDER_CONDITIONS, params.orderId];
};

export const getFindOrderConditionsCustomFieldsKey = (): UseDataQuery['queryKey'] => [
  'orders/order-conditions/custom-fields',
];

export const getFindOrderConditionsClassificationTypesKey = (
  params: FindOrderConditionsClassificationTypesParams,
): UseDataQuery['queryKey'] => [
  DataQueryKey.ORDER_CONDITIONS_CLASSIFICATION_TYPES,
  undefined,
  params,
];

export const getFindOrderConditionFreightQuotesKey = ({
  orderId,
  orderConditionId,
}: FindOrderConditionFreightQuotesParams): UseDataQuery['queryKey'] => [
  'orders/:orderId/order-conditions/:orderConditionId/freight-quotes',
  orderId,
  orderConditionId,
];
